import o from "./_baseGetTag.js";
import r from "./isObject.js";
var e = "[object AsyncFunction]", a = "[object Function]", c = "[object GeneratorFunction]", i = "[object Proxy]";
function g(n) {
  if (!r(n))
    return !1;
  var t = o(n);
  return t == a || t == c || t == e || t == i;
}
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isFunction.js
// module id = 470
// module chunks = 67